<template>
  <el-image
    :src="displaySrc"
    :key="reloadKey"
    v-bind="$attrs"
    @error="onError"
  >
    <slot></slot>
  </el-image>
</template>

<script>
export default {
  name: 'SignedImage',
  inheritAttrs: false,
  // 与 el-image 的 src 语义一致；支持 裸URL / 签名URL / 静态资源路径
  props: {
    src: { type: String, default: '' }
  },
  data() {
    return {
      displaySrc: '',
      reloadKey: 0,
      signing: false,
      retried: false
    };
  },
  watch: {
    src: {
      immediate: true,
      handler(val) {
        this.retried = false;
        this.resolve(val);
      }
    }
  },
  methods: {
    async resolve(raw) {
      if (!raw) { this.displaySrc = raw; return; }
      // 临近过期时提前重签，避免 403 闪裂（仅对私有 bucket 签名 URL 生效）
      if (this.$isOssExpired && this.$isOssExpired(raw)) {
        try {
          const fresh = await this.$reSignOss(raw);
          if (fresh) { this.displaySrc = fresh; return; }
        } catch (e) {
          // 重签失败则继续用原值，交给 @error 兜底
        }
      }
      this.displaySrc = raw;
    },
    async onError() {
      // 加载失败（如签名过期 403）：剥签名重签一次后重试
      if (this.signing || this.retried) return;
      if (!this.displaySrc || this.displaySrc.indexOf('oss.jinding.work') === -1) return;
      this.signing = true;
      try {
        const fresh = await this.$reSignOss(this.displaySrc);
        if (fresh && fresh !== this.displaySrc) {
          this.displaySrc = fresh;
          this.reloadKey++;   // 强制 el-image 重新加载新 URL
          this.retried = true;
        }
      } catch (e) {
        // 重签失败，保持错误态，不无限重试
      } finally {
        this.signing = false;
      }
    }
  }
};
</script>
